import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { CountItem } from '@frontend/sports/common/core/data-access/sport-model';
import { ModalDialogOptions, ModalDialogService, ModalRef } from '@frontend/sports/modal/feature';
import { CompetitionRoute } from '@frontend/sports/navigation/core/feature/models';
import { cloneDeep } from 'lodash-es';

import { CalendarCompetitionTreeComponent } from './calendar-competition-tree.component';

@Injectable()
export class CalendarCompetitionTreeModalDialogService {
    private dialogOptions: ModalDialogOptions<Pick<CalendarCompetitionTreeComponent, 'sport' | 'context'>>;
    private openModalHandle: ModalRef | null = null;

    constructor(
        private modalDialogService: ModalDialogService,
        private sitecore: Sitecore,
    ) {
        this.dialogOptions = {
            settings: {
                cssClass: 'modal-popup calendar-countries-list-modal',
                fit: false,
                showDialogHeader: true,
                title: this.sitecore.globalMessages.AllCountriesList,
                hideCloseButton: false,
                isModalDialog: true,
            },
        };
    }

    openDialog(sport: CountItem | undefined, contextData: CompetitionRoute): ModalRef {
        if (!this.openModalHandle) {
            this.close();
            const dialogModel = cloneDeep(sport);
            if (dialogModel) {
                dialogModel.children = dialogModel.children.filter((region) => region.children.length);
                this.dialogOptions.data = { sport: dialogModel, context: contextData };
            }

            this.openModalHandle = this.modalDialogService.openDialog(CalendarCompetitionTreeComponent, this.dialogOptions);
            this.openModalHandle.result.then(() => this.close()).catch(() => this.close());
        }

        return this.openModalHandle;
    }

    private close(): void {
        if (this.openModalHandle) {
            this.openModalHandle.close();
            this.openModalHandle = null;
        }
    }
}
